<template>
  <div class="modal-content">
    <div class="modal-body" ref="modalContentScroll">
      <div class="fields-container">
        <div class="section">
          <img :src="icono" alt="icono" class="icono" />
        </div>
        <div class="section">
          <div class="message">
            <p class="h1-heroMuni">{{ message?.one }}</p>
            <p class="h1-heroMuni">{{ message?.two }}</p>
          </div>
        </div>
      </div>
      <div class="section btns">
        <button class="actionBtn h2-heroMuni" @click="doConfirm()">
          {{ confirm }}
        </button>
        <button class="actionBtn h2-heroMuni" @click="doCancel()">
          {{ cancel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(["close-modal", "open-modal"]);
const props = defineProps({
  icono: {
    type: String,
    default: null,
  },
  message: {
    type: Object,
    default: null,
  },
  onConfirm: {
    type: Function,
    default: null,
  },
  onCancel: {
    type: Function,
    default: null,
  },
  confirm: {
    type: String,
    default: "Si",
  },
  cancel: {
    type: String,
    default: "No",
  },
});

const doConfirm = async () => {
  props.onConfirm() ?? emit("close-modal");
};

const doCancel = async () => {
  props.onCancel() ?? emit("close-modal");
};
</script>

<style scoped>
@import "@/components/Utils/css/form-styles.css";
p,
h2,
h3 {
  margin: unset;
}

.h1-heroMuni {
  /* font-size: 18px; */
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.25rem; /* 111.111% */
}

.img-min {
  width: 1.25rem;
  height: 1.25rem;
  object-fit: contain;
  width: fit-content;
}

.modal-content {
  height: 47vh;
  width: 40vw;
  display: flex;
  flex: 1 1 auto;
}

.modal-header {
  padding: 1rem;
  padding-bottom: unset;
}

.modal-body {
  padding: unset;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0rem 2rem 1.875rem 2rem;
}

.section {
  display: flex;
  flex-direction: column;
  height: fit-content;
  gap: 0.94rem;
  align-items: center;
}

.section.btns {
  justify-content: center;
  flex-direction: row;
}

.icono {
  /* width: 9.09vw; */
  width: 7.32vw;
}

.h2-small {
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.03px;
}

.textAreaExpanded {
  min-height: 8.125rem;
}

.fields-container {
  display: flex;
  flex-direction: column;
  gap: 1.88rem;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
}

.actionBtn {
  width: 11.5rem;
  border-radius: 0.625rem;
  border: none;
  background-color: var(--text-primary);
  color: var(--bg-popup);

  padding-top: 0.3rem;
  padding-bottom: 0.3rem;

  display: flex;
  justify-content: center;
  align-items: center;
}

.message {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* ------------------ MOBILE ------------------ */
@media (max-width: 768px) {
  .modal-content {
    gap: 1.27vh;
    width: 77.78vw;
    height: 30.61vh;
    padding: 3.96vh 4.44vw;
    justify-content: flex-start;
  }
  .logo {
    width: 45.78vw;
    height: auto;
  }
  .icono {
    width: 11.11vw;
  }
  .modal-body {
    height: 100%;
    padding-bottom: 0px;
    justify-content: center;
  }
  .fields-container {
    align-items: flex-start;
    flex-direction: row;
    gap: 0.31rem;
    flex: 0;
    margin-bottom: 1.25rem;
    /* height: fit-content; */
    justify-content: center;
  }
  .acciones {
    flex-direction: column;
    align-items: center;
    gap: 1.27vh;
    margin: unset;
  }
  .acciones button {
    display: flex;
    width: 41.64vw;
    padding: 0.96vh 0.732vw;
    justify-content: center;
    align-items: center;
    border-radius: 0.625rem;
  }

  .section.btns {
    justify-content: center;
    flex-direction: column;
  }
}
</style>
